import vv_utils from './vv_utils';
import { fullLoadingInvokeMachine } from "./vv_api";

function setupTotp(totpConfig) {

///////////////////////////////////////

/*  const totpConfig = {
    pageAlertbox: credAlertbox,
    formAlertbox: credAlertbox,
    modal: totpModalBS,
    totpImg: document.getElementById('vv-modal-add-totp-img'),
    cancelBtn: document.getElementById('vv-modal-add-totp-cancel'),
    verifyBtn: document.getElementById('vv-modal-add-totp-verify'),
    codeInput: document.getElementById('vv-modal-add-totp-code'),
    form: document.getElementById('vv-modal-add-totp-form'),
    pageLoadService: dataLoadService
  }*/

  const fieldFormMap = {
    'code': '#vv-modal-add-totp-code',
  }
  ///////////////////////////

  function checkValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      
      
      
      
      
      totpConfig.codeInput.value = totpConfig.codeInput.value.replace(/[^\d]+/g, '');

      if (totpConfig.codeInput.value.length === 6 && /^\d+$/.test(totpConfig.codeInput.value)) {
        //
      } else {
        vv_utils.makeInvalid(totpConfig.codeInput);
        valid = false;
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function load(context, event) {
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/totp/generate`, context.data);
  }

  function update(context, event) {
    
    
    
    
    const req = {
      "token": totpConfig.codeInput.getAttribute("data-token"),
      "code": totpConfig.codeInput.value,
    }    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/totp/verify`, req);
  }

  const { interpret } = window.XState;
  const editModalService = interpret(
    fullLoadingInvokeMachine.withConfig({
      actions: {
        loaded: (context, event) => {
          
          

          
          
          vv_utils.clearInputValidation(totpConfig.form);
          vv_utils.clearalert(totpConfig.formAlertbox);
          vv_utils.clearalert(totpConfig.pageAlertbox);
          let generateRes = context.data;
          const qrcodeBlob = new Blob([generateRes.image], { type: 'image/svg+xml' });
          totpConfig.totpImg.src = URL.createObjectURL(qrcodeBlob);
          totpConfig.codeInput.value = "";
          totpConfig.codeInput.setAttribute("data-token", generateRes.token)
          totpConfig.modalBS.show();          
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(totpConfig.form);
          vv_utils.clearalert(totpConfig.formAlertbox);
          vv_utils.clearalert(totpConfig.pageAlertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", totpConfig.formAlertbox);
        },
        validationSucceeded: (context, event) => {
          
          
          
          editModalService.send("PERFORM_ACTION", { "id": context.data.id, });
        },
        actionFailed: (context, event) => {
          
          //TODO make this for cred object not password
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, fieldFormMap);
          }
          if (context.error) {  
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, totpConfig.formAlertbox);
          }
        },
        actionSucceeded: (context, event) => {
          vv_utils.showalert("Updated successfully.", "primary", totpConfig.formAlertbox);
          totpConfig.modalBS.hide();
          
          //add a tiny delay to allow save to finish before modal showing
          totpConfig.pageLoadService.send("SUBMIT");
          editModalService.send("RE_INIT");
        }
      },
      services: {
        loading_service: (context, event) => load(context, event),
        validate_service: (context, event) => checkValidity(context, event),
        action_service: (context, event) => update(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  vv_utils.AttachAndSendFormEventsToMachineService(totpConfig.form, editModalService, 'input', 'input');
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(totpConfig.form, editModalService, (e)=>{if (e.preventDefault) e.preventDefault()});

  
  
  totpConfig.modal.addEventListener('hidden.bs.modal', function (event) {
    editModalService.send("RE_INIT");
  })


  totpConfig.verifyBtn.addEventListener('click', (e) => {
    editModalService.send("PERFORM_ACTION");
  });

  editModalService.send("INIT_COMPLETE");
//////////////////////////////////////////  

};